"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/features/object/values");
require("core-js/features/array/includes");
var Request = require("../request");
var common_1 = require("./common");
var howToGetMerchantKey = "To get a Merchant API key you need to " +
    "register with Findify and finish the onboarding process.";
function validateConfig(config, isBrowserEnv) {
    var key = config.key, user = config.user, method = config.method, log = config.log;
    validateAPIKey(key);
    if (typeof method !== 'undefined' &&
        !Object.values(Request.Method).includes(method)) {
        throw new Error('"method" param should be either "post" or "jsonp"');
    }
    if (!isBrowserEnv && config.method === Request.Method.JSONP) {
        throw new Error('jsonp method is not allowed in node environment');
    }
    if (typeof log !== 'undefined' && typeof log !== 'boolean') {
        throw new Error('"log" param should be "boolean" type');
    }
}
exports.validateConfig = validateConfig;
function validateAPIKey(key) {
    if (key == null) {
        throw new Error("\"key\" param is missing. " + howToGetMerchantKey);
    }
    if (typeof key !== 'string') {
        throw new Error('"key" param should be a string. ' + howToGetMerchantKey);
    }
    if (key.trim().length < 1) {
        throw new Error('"key" param can not be an empty or only-whitespace string. ' +
            howToGetMerchantKey);
    }
}
function validateAutocomplete(params) {
}
exports.validateAutocomplete = validateAutocomplete;
function validateSearch(params) {
    common_1.validatePresence('q', params.q);
    common_1.validateList(params);
}
exports.validateSearch = validateSearch;
function validateSmartCollection(params) {
    common_1.validatePresence('slot', params.slot);
    common_1.validateList(params);
}
exports.validateSmartCollection = validateSmartCollection;
function validateRecommendations(params) {
    common_1.validatePresence('type', params.type);
    if (!Object.values(Request.Recommendations.Type).includes(params.type)) {
        throw new Error('Invalid "recommendation" type');
    }
    if (params.type === Request.Recommendations.Type.Slot) {
        common_1.validatePresence('slot', params.slot);
    }
    if (params.type === Request.Recommendations.Type.AlsoViewed ||
        params.type === Request.Recommendations.Type.AlsoBought) {
        common_1.validatePresence('item_id', params.item_id);
    }
    if (params.type === Request.Recommendations.Type.FrequentlyPurchasedTogether) {
        common_1.validatePresence('item_ids', params.item_ids);
    }
}
exports.validateRecommendations = validateRecommendations;
function validateFeedback(params) {
    common_1.validatePresence('event', params.event);
    switch (params.event) {
        case Request.Feedback.Event.ClickSuggestion:
        case Request.Feedback.Event.Redirect:
            common_1.validatePresence('rid', params.rid);
            common_1.validatePresence('suggestion', params.suggestion);
            break;
        case Request.Feedback.Event.ClickItem:
        case Request.Feedback.Event.AddToCart:
            common_1.validatePresence('item_id', params.item_id);
            break;
        case Request.Feedback.Event.Purchase:
            common_1.validatePresence('order_id', params.order_id);
            common_1.validatePresence('currency', params.currency);
            common_1.validatePresence('revenue', params.revenue);
            common_1.validateLineItems(params.line_items);
            break;
        case Request.Feedback.Event.UpdateCart:
            common_1.validateLineItems(params.line_items);
            break;
        case Request.Feedback.Event.ViewPage:
            common_1.validatePresence('url', params.url);
            common_1.validatePresence('ref', params.ref);
            common_1.validatePresence('width', params.width);
            common_1.validatePresence('height', params.height);
            break;
        default:
            throw new Error('Invalid "event" type');
    }
}
exports.validateFeedback = validateFeedback;
function validateUser(user) {
    if (user == null) {
        throw new Error('"user" param should be provided either at request or at library config');
    }
    common_1.validatePresence('user.uid', user.uid);
    common_1.validatePresence('user.sid', user.sid);
}
exports.validateUser = validateUser;
//# sourceMappingURL=index.js.map